import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';
const routes = {
  name: 'Cash',
  icon: 'mdi-cash',
  path: '/reports/cash',
  menuFilters: multiClientMenuFilters,
  ...addPermissionsToRoute(['mtCash']),

  children: [
    {
      path: '/reports/cash/cashSheet',
      name: 'Cash Sheet',
      meta: { id: 'reports-mtCashSheet' },
      component: () => import('./cashsheet/CashsheetWrapper.vue'),
    },
    {
      path: '/reports/cash/tax',
      name: 'Tax Exempt',
      meta: { id: 'reports-mtTax' },
      component: () => import('./tax/TaxWrapper.vue'),
    },
    {
      path: '/reports/cash/registerAudit',
      name: 'Register Audit',
      meta: { id: 'reports-mtRegisterAudit' },
      component: () => import('./RegisterAudit.vue'),
    },
    {
      path: '/reports/cash/cashless',
      name: 'Cashless',
      meta: { id: 'reports-mtCashless' },
      component: () => import('./Cashless.vue'),
    },
    // {
    //   path: '/reports/cash/cashless',
    //   name: 'Cashless',
    //   meta: { id: 'mc-cashless' },
    //   component: () => import('./CashlessWrapper.vue'),
    //   ...addPermissionsToRoute(['mtCash']),
    // },
    // {
    //   path: '/reports/cash/giftCardSummary',
    //   name: 'Gift Card Summary',
    //   meta: { id: 'mc-giftCardSummary' },
    //   component: () => import('./GiftCardSummary.vue'),
    //   ...addPermissionsToRoute(['mtCash']),
    // },
  ],
};

export default routes;
